import { useNavigate } from "react-router-dom";
import ExternalLink from "../../../../assets/svg/External_Link.svg";
import { RouterPaths } from "../../../../router/router";
import { Link } from "react-router-dom";


const About = ({ aSubManuItem, setASubManuItem, openAbout, subMenuWidth, closeAllManu, height }) => {
  const navigate = useNavigate();
  return (
    <div
      onMouseEnter={() => openAbout()}
      onMouseLeave={() => closeAllManu()}
      className={`absolute z-[10001]`}
      style={{ left: `${subMenuWidth.offsetLeft - 305}px` }}
    >
      <div className="mr-[33px]" style={{ top: `${height}px`, width: `${subMenuWidth.offsetWidth + 305}px` }}>
        <div className="bg-[#F2F2F2]">
          <div className="grid grid-cols-4 gap-4">
            <div className="col-span-1 border-r-[1px] border-r-[#292929]">
              <div className="border-b-[1px] border-b-black py-[8px] cursor-pointer">
                <div
                  className={`${aSubManuItem == "ABOUT_TUATARA" ? "border-l-[#7ABF5B] font-bold" : "border-l-[#292929] font-normal"
                    }  text-[20px] font-[Roboto] text-[#000] border-l-[11px] px-[34px] py-[26px]`}
                  onMouseEnter={() => setASubManuItem("ABOUT_TUATARA")}
                >
                  ABOUT TUATARA
                </div>
              </div>
              {/* <div className="border-b-[1px] border-b-black py-[8px] cursor-pointer">
                <div
                  className={`${
                    aSubManuItem == "INVESTORS" ? "border-l-[#7ABF5B] font-bold" : "border-l-[#292929] font-normal"
                  }  text-[20px] font-[Roboto] text-[#000] border-l-[11px] px-[34px] py-[26px]`}
                  onMouseEnter={() => setASubManuItem("INVESTORS")}
                >
                  INVESTORS
                </div>
              </div>
              <div className="border-b-[1px] border-b-black py-[8px] cursor-pointer">
                <div
                  className={`${
                    aSubManuItem == "COMMUNITY" ? "border-l-[#7ABF5B] font-bold" : "border-l-[#292929] font-normal"
                  }  text-[20px] font-[Roboto] text-[#000] border-l-[11px] px-[34px] py-[26px]`}
                  onMouseEnter={() => setASubManuItem("COMMUNITY")}
                >
                  COMMUNITY
                </div>
              </div> */}
            </div>

            {/* ABOUT TUATARA A DEALER */}
            {aSubManuItem == "ABOUT_TUATARA" ? (
              <div className="col-span-3 mx-[47px]">
                <div className="pt-[35px] pb-[25px] border-b-[1px] border-b-[#292929] font-bold text-[20px] font-[Roboto] text-[#000]">
                  ABOUT TUATARA
                </div>
                <div className="flex mt-[41px]">
                  {/* Left Side - Auto Width */}
                  <div className="flex-grow col-span-2 border-r-[1px] border-r-[#292929]">
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(RouterPaths.About);
                        closeAllManu();
                      }}
                    >
                      About Tuatara
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e] flex items-center"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      History
                    </div>
                    {/* <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Contact US
                    </div> */}
                  </div>

                  {/* Right Side - Fixed Width */}
                  <div className="w-[450px] px-[40px]">
                    <div>
                      <div className="font-bold text-[20px] font-[Roboto] text-[#000]">Let’s Get To Work. </div>
                      <div>
                        <div className="font-normal text-[20px] font-[Roboto] text-[#000] mt-[20px]">
                          There is work to be done worldwide, and that work is powered by Tuatara and our people. Join
                          the team.
                        </div>
                      </div>
                    </div>
                    <div className=" mt-[21px] mb-[38px]">
                      <button
                        className="w-full border-[4px] border-[#7abf5b] text-[#fff] bg-[#7abf5b] font-[Roboto] text-[20px] text-[#fff]  py-[10px] font-bold my-[10px]"
                        style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                      >
                        <Link
                          to="/us/about"
                          onClick={() => {
                            window.scrollTo(0, 0);
                            closeAllManu();
                          }}
                        >
                          ABOUT TUATARA
                        </Link>
                      </button>
                      {/* <button
                        className="w-full border-[4px] border-[#7abf5b] text-[#5b792e] font-[Roboto] text-[20px] py-[10px] font-bold my-[10px]"
                        style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                      >
                        EXPLORE CAREERS
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}


            {/* INVESTORS */}
            {aSubManuItem == "INVESTORS" ? (
              <div className="col-span-3 mx-[47px]">
                <div className="pt-[35px] pb-[25px] border-b-[1px] border-b-[#292929] font-bold text-[20px] font-[Roboto] text-[#000]">
                  INVESTORS
                </div>
                <div className="flex mt-[41px]">
                  {/* Left Side - Auto Width */}
                  <div className="flex-grow col-span-2 border-r-[1px] border-r-[#292929]">
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Register to Invest
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e] flex items-center"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Become a Dealer
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Resources
                    </div>
                  </div>

                  {/* Right Side - Fixed Width */}
                  <div className="w-[450px] px-[40px]">
                    <div>
                      <div className="font-bold text-[20px] font-[Roboto] text-[#000]">We Are Global</div>
                      <div>
                        <div className="font-normal text-[20px] font-[Roboto] text-[#000] mt-[20px]">
                          Tuatara and Tuatara dealers across the globe are
                          working to support our customers and their
                          communities.
                        </div>
                      </div>
                    </div>
                    <div className="mt-[37px] mb-[24px]">
                      <div className="font-bold text-[20px] font-[Roboto] text-[#000]">History</div>
                      <div>
                        <div className="font-normal text-[20px] font-[Roboto] text-[#000] mt-[20px]">
                          Explore the history of Tuatara, including the story of our two founders.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {/* COMMUNITY */}
            {aSubManuItem == "COMMUNITY" ? (
              <div className="col-span-3 mx-[47px]">
                <div className="pt-[35px] pb-[25px] border-b-[1px] border-b-[#292929] font-bold text-[20px] font-[Roboto] text-[#000]">
                  COMMUNITY
                </div>
                <div className="flex mt-[41px]">
                  {/* Left Side - Auto Width */}
                  <div className="flex-grow col-span-2 border-r-[1px] border-r-[#292929]">
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Philanthropy
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e] flex items-center"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Event Calendar
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Media Hub
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Sponsorships & Affiliates
                    </div>
                  </div>

                  {/* Right Side - Fixed Width */}
                  <div className="w-[450px] px-[40px]">
                    <div>
                      <div className="font-bold text-[20px] font-[Roboto] text-[#000]">Sponsorship & Affiliates</div>
                      <div>
                        <div className="font-normal text-[20px] font-[Roboto] text-[#000] mt-[20px]">
                          If you believe your organization is a good fit and partnering with us can provide value and
                          positively increase the Tuatara brand, check out our sponsorship application form.
                        </div>
                      </div>
                    </div>
                    <div className="w-full mt-[21px] mb-[23px]">
                      <button
                        className="border-[4px] border-[#7abf5b] text-[#5b792e] font-[Roboto] text-[20px] px-[30px] py-[10px] font-bold my-[10px]"
                        style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                      >
                        SPONSORSHIP FORM
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {/* TRAINING */}
            {aSubManuItem == "TRAINING" ? (
              <div className="col-span-3 mx-[47px]">
                <div className="pt-[35px] pb-[25px] border-b-[1px] border-b-[#292929] font-bold text-[20px] font-[Roboto] text-[#000]">
                  TRAINING
                </div>
                <div className="flex mt-[41px]">
                  {/* Left Side - Auto Width */}
                  <div className="flex-grow col-span-2 border-r-[1px] border-r-[#292929]">
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Operator Training & Videos
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e] flex items-center"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Safety Training & PPE
                    </div>
                    <div
                      className="font-normal text-[20px] font-[Roboto] text-[#000] cursor-pointer pb-[33px] hover:font-bold hover:text-[#5b792e]"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("#");
                        closeAllManu();
                      }}
                    >
                      Power System Training
                    </div>
                  </div>

                  {/* Right Side - Fixed Width */}
                  <div className="w-[450px] px-[40px]">
                    <div>
                      <div className="font-bold text-[20px] font-[Roboto] text-[#000]">Dealer Network</div>
                      <div>
                        <div className="font-normal text-[20px] font-[Roboto] text-[#000] mt-[20px]">
                          Your local Tuatara dealer is a personal partner who will do whatever it takes to help you
                          succeed.
                        </div>
                      </div>
                    </div>
                    <div className=" mt-[21px] mb-[23px]">
                      {/* <button
                        className="border-[4px] border-[#7abf5b] text-[#5b792e] bg-[#fff] font-[Roboto] text-[20px] text-[#fff] px-[30px] py-[10px] font-bold my-[10px]"
                        style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                      >
                        FIND A DEALER
                      </button> */}
                      <button
                        className="border-[4px] border-[#7abf5b] text-[#fff] bg-[#7abf5b] font-[Roboto] text-[20px] text-[#fff] px-[30px] py-[10px] font-bold my-[10px]"
                        style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                      >
                        BECOME A DEALER
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
export default About;
